import { z } from 'zod/mini'

import { amount } from './fields'
import { nonEmptyString } from './non-empty-string'

/**
 * Item keys every Back Market producer sends. Descriptive dimensions accept
 * the `''` fallbacks used when the source has no value; identity is enforced
 * by `itemObject` (one of `item_id` / `item_name`).
 */
export const itemShape = {
  item_legacy_id: z.string(),
  item_id: z.string(),
  item_name: z.string(),
  affiliation: z.string(),
  discount: amount(),
  index: z.number().check(z.gte(0)),
  item_brand: z.string(),
  item_category: z.string(),
  item_variant: z.string(),
  item_warranty_duration: z.string(),
  // Market country code, always available
  location_id: nonEmptyString(),
  price: amount(),
  quantity: z.number().check(z.gt(0)),
  google_business_vertical: z.literal('retail'),
}

/** Items built by the recommendation layer (`toGa4ProductItem`). */
export const listItemShape = {
  ...itemShape,
  // Undefined when the product has no category or price
  item_category: z.optional(z.string()),
  price: z.optional(amount()),
  // Raw list name, empty when the component has none
  item_list_id: z.string(),
  item_list_name: z.string(),
}
